export const PICK_UP_WHERE_YOU_LEFT_OFF_ANCHOR = "pick-up-where-you-left-off";

export const getDashboardDockDestination = (dashboardUrl: string, resumableCount: number) =>
  resumableCount > 0 ? `${dashboardUrl}#${PICK_UP_WHERE_YOU_LEFT_OFF_ANCHOR}` : dashboardUrl;

export const shouldShowInProgressReminder = ({
  pathname,
  loggedIn,
  customerId,
  isCustomer,
}: {
  pathname: string;
  loggedIn: boolean;
  customerId?: string | null;
  isCustomer?: boolean;
}) =>
  !pathname.startsWith("/school") &&
  !pathname.startsWith("/coach") &&
  !pathname.startsWith("/account/favorites") &&
  !pathname.startsWith("/dash") &&
  !loggedIn &&
  !!isCustomer &&
  !!customerId;
